(() => {
    document.addEventListener("DOMContentLoaded", function () {

        const referer = document.referrer;

        let needToReplace = false;
        let thumbnail = '';
        let linkText = '';
        
        if (referer.endsWith('street-name-workflow')) {
            needToReplace = true;
            thumbnail = '/media/images/snn_cop/flow1_edited.png';
            linkText = 'Workflow diagram 1';
        }

        if (referer.endsWith('street-name-with-properties-workflow')) {
            needToReplace = true;
            thumbnail = '/media/images/snn_cop/flow2_edited.png';
            linkText = 'Workflow diagram 2';
        }

        if (referer.endsWith('renumber-rename-properties-workflow')) {
            needToReplace = true;
            thumbnail = '/media/images/snn_cop/flow3_edited.png';
            linkText = 'Workflow diagram 3';
        }

        if (needToReplace == true) {

            //const parentNav = $('ul.pagination');
            //const listItem = parentNav.children(":first");

            //if (listItem != null && listItem != undefined) {
            //    const newItem = document.createElement('li');
            //    newItem.innerHTML = '<a href="' + referer + '"><img src="' + thumbnail +'" max-width="40" width="40" alt="back to workflow diagram"/></a>';
            //    listItem.replaceWith(newItem);
            //}

            $('ul.pagination').remove();

            const header = $('#article-title');
            const newDiv = document.createElement('div');
            newDiv.innerHTML = '<a href="' + referer + '" style="text-decoration:none;"><img src="' + thumbnail + '" max-width="80" width="80" class="mb-3" alt="back to workflow diagram"/> ' + linkText +'</a> ';

            header.after(newDiv);
        }
    });
})();




